import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { hasWorkflowOpsAccess } from "app/routes/workflowOperations/access";

export class Menu extends Component {
  componentDidMount() {
    const { history } = this.props;

    const pathname = `#${history.location.pathname}`;
    const mainMenu = document.getElementsByClassName("nav-item");
    for (let i = 0; i < mainMenu.length; i++) {
      mainMenu[i].onclick = function() {
        for (let j = 0; j < mainMenu.length; j++) {
          if (mainMenu[j].classList.contains("active")) {
            mainMenu[j].classList.remove("active");
          }
        }
        this.classList.toggle("active");
      };
    }
    const subMenuLi = document.getElementsByClassName("nav-arrow");
    for (let i = 0; i < subMenuLi.length; i++) {
      subMenuLi[i].onclick = function() {
        for (let j = 0; j < subMenuLi.length; j++) {
          if (subMenuLi[j].classList.contains("active")) {
            subMenuLi[j].classList.remove("active");
          }
        }
        this.classList.toggle("active");
      };
    }
    const activeLi = document.querySelector(`a[href="${pathname}"]`);
    try {
      const activeNav = this.closest(activeLi, "ul");
      if (activeNav.classList.contains("sub-menu")) {
        this.closest(activeNav, "li").classList.add("active");
      } else {
        this.closest(activeLi, "li").classList.add("active");
      }
      const parentNav = this.closest(activeNav, ".nav-item");
      if (parentNav) {
        parentNav.classList.add("active");
      }
    } catch (e) {}
  }

  closest(el, selector) {
    try {
      let matchesFn;
      [
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector",
      ].some(function(fn) {
        if (typeof document.body[fn] === "function") {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {}

    return null;
  }

  render() {
    const { authUser } = this.props;
    const hasAdminAccess =
      authUser && authUser.Claims.includes("admin.access");
    const canOpenWorkflowOps = hasWorkflowOpsAccess(authUser);

    return (
      <div className="app-main-menu d-none d-md-block">
        <ul className="navbar-nav navbar-nav-mega">
          <li className="nav-item">
            <span className="nav-link">
              <IntlMessages id="sidebar.main" />
            </span>
            <ul className="sub-menu">
              <li className="nav-arrow">
                <span className="nav-link">
                  <i className="zmdi zmdi-chart-donut zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.smartfolioAccuracy" />
                  </span>
                </span>
                <ul className="sub-menu">
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/smartfolio-accuracy/overall"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.smartfolioAccuracy.overall" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/smartfolio-accuracy/smartcard"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.smartfolioAccuracy.smartCardAnalysis" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/smartfolio-accuracy/signal-performance"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.smartfolioAccuracy.signalPerformance" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/smartfolio-accuracy/signal-constituents"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.smartfolioAccuracy.signalConstituents" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
              {hasAdminAccess ? (
                <li className="nav-arrow">
                  <span className="nav-link">
                    <i className="zmdi zmdi-swap zmdi-hc-fw" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.accountTransfers" />
                    </span>
                  </span>
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/account-transfers/config"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.accountTransfers.config" />
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/account-transfers/activity"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.accountTransfers.activity" />
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/account-transfers/attention"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.accountTransfers.attention" />
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              ) : null}
              <li className="nav-arrow">
                <span className="nav-link">
                  <i className="zmdi zmdi-wrench zmdi-hc-fw" />
                  <span className="nav-text">
                    <IntlMessages id="sidebar.serviceCenter" />
                  </span>
                </span>
                <ul className="sub-menu">
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/service-center/trading"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.serviceCenter.trading" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/service-center/account"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.serviceCenter.account" />
                      </span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      className="prepend-icon"
                      to="/app/service-center/batch-ops"
                    >
                      <span className="nav-text">
                        <IntlMessages id="sidebar.serviceCenter.batchOps" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </li>
              {canOpenWorkflowOps ? (
                <li className="nav-arrow">
                  <span className="nav-link">
                    <i className="zmdi zmdi-widgets zmdi-hc-fw" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.workflowOps.workbench" />
                    </span>
                  </span>
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/workflow-operations/control-tower"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.workflowOps.controlTower" />
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/workflow-operations/trades"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.workflowOps.trades" />
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/workflow-operations/smartfolio-sessions"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.workflowOps.smartfolioSessions" />
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              ) : null}
              {hasAdminAccess ? (
                <li className="nav-arrow">
                  <span className="nav-link">
                    <i className="zmdi zmdi-open-in-new zmdi-hc-fw" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.abr" />
                    </span>
                  </span>
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/abr/preview"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.abr.preview" />
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              ) : null}
              {hasAccountTransfersAccess ? (
                <li className="nav-arrow">
                  <span className="nav-link">
                    <i className="zmdi zmdi-open-in-new zmdi-hc-fw" />
                    <span className="nav-text">
                      <IntlMessages id="sidebar.abr" />
                    </span>
                  </span>
                  <ul className="sub-menu">
                    <li>
                      <NavLink
                        exact
                        className="prepend-icon"
                        to="/app/abr/preview"
                      >
                        <span className="nav-text">
                          <IntlMessages id="sidebar.abr.preview" />
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              ) : null}
            </ul>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authUser: state.auth?.authUser || null,
});

export default connect(mapStateToProps)(withRouter(Menu));
